import { render, staticRenderFns } from "./tablaCategoria.vue?vue&type=template&id=6f351893&scoped=true&"
import script from "./tablaCategoria.vue?vue&type=script&lang=js&"
export * from "./tablaCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f351893",
  null
  
)

export default component.exports